<template>
  <v-icon
    class="drag-handle"
    :title="trans('general.dragAndDropReorderTitle')"
    style="cursor: move"
  >mdi-drag</v-icon>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';

export default {
  name: 'DragHandle',
  mixins: [
    LocaleUtils
  ]
}
</script>

<style scoped>

</style>
